import { render, staticRenderFns } from "./paypalForm.vue?vue&type=template&id=076c556c"
import script from "./paypalForm.vue?vue&type=script&lang=js"
export * from "./paypalForm.vue?vue&type=script&lang=js"
import style0 from "./paypalForm.vue?vue&type=style&index=0&id=076c556c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports